/* Live Free — press kit. Copy-to-clipboard with a confirmed state.
   ~1KB. Downloads are plain anchors and need no script. */
(function () {
  'use strict';

  function flash(btn, doneLabel, idleLabel) {
    btn.textContent = doneLabel;
    btn.classList.add('is-done');
    window.setTimeout(function () {
      btn.textContent = idleLabel;
      btn.classList.remove('is-done');
    }, 2000);
  }

  // Fallback for browsers without the async clipboard API.
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-lf-copy]');
    if (!btn) return;

    var source = document.getElementById(btn.dataset.lfCopy);
    if (!source) return;

    var text = source.textContent.trim();
    var idle = btn.dataset.lfCopyLabel || btn.textContent;
    var done = btn.dataset.lfCopyDone || 'Copied';

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        flash(btn, done, idle);
      }).catch(function () {
        if (legacyCopy(text)) flash(btn, done, idle);
      });
    } else if (legacyCopy(text)) {
      flash(btn, done, idle);
    }
  });
})();